<template>
	<div>
		<!-- 新增、编辑合同 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="700" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<div v-if="title=='新增入住'" style="margin-left: 50px;margin-top:-20px;color: red;margin-bottom:20px;">* 新增入住时，请先添加人才信息</div>
			<el-form :model="formData" ref="formData" :rules="rules" label-width="130px">
				<div style="display: flex;justify-content: space-between;">
					<el-form-item prop="names" label="人才姓名">
						<el-autocomplete :disabled="isShow" v-model="formData.names" :fetch-suggestions="querySearchAsync"
							placeholder="请选择人才姓名" value-key="name" clearable @clear="clearSearch" @select="handleSelect"
							ref="myAutocomplete">
						</el-autocomplete>
					</el-form-item>
					<el-form-item prop="company" label="所属单位">
						<el-input :disabled="isShow" v-model="formData.company" disabled=""></el-input>
					</el-form-item>
				</div>
				<div style="display: flex;justify-content: space-between;">
					<el-form-item prop="water" label="水电缴费方式">
						<el-select :disabled="isShow" v-model="formData.water" placeholder="请选择水电缴费方式">
							<el-option label="个人缴纳" value="个人缴纳"></el-option>
							<el-option label="单位缴纳" value="单位缴纳"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="property" label="服务费缴费方式">
						<el-select :disabled="isShow" v-model="formData.property" placeholder="请选择服务费缴费方式">
							<!-- <el-option label="个人缴纳" value="个人缴纳"></el-option> -->
							<el-option label="单位缴纳" value="单位缴纳"></el-option>

						</el-select>
					</el-form-item>
				</div>
				<el-form-item v-if="!isShow&&isAdd" prop="roomNumber" label="房间号">
					<el-cascader :disabled="isShow" v-model="formData.roomNumber" :options="options" placeholder="请选择客房"
						:show-all-levels="false" clearable></el-cascader>
				</el-form-item>
				<el-form-item v-else prop="roomNum" label="房间号">
					<el-input :disabled="isShow" v-model="formData.roomNum" disabled=""></el-input>
				</el-form-item>
				<div style="display: flex;justify-content: space-between;">
					<el-form-item prop="checkInTime" label="入住日期">
						<el-date-picker :disabled="isShow" type="date" placeholder="选择入住日期" :picker-options="pickerOptions1"
						value-format='yyyy-MM-dd HH:mm:ss'	v-model="formData.checkInTime" style="width:100%;">

						</el-date-picker>
					</el-form-item>
					<el-form-item prop="endTime" label="截止日期">
						<el-date-picker :picker-options="pickerOptions" :disabled="isShow" type="date" placeholder="选择截止日期"
						value-format='yyyy-MM-dd HH:mm:ss' v-model="formData.endTime" style="width:100%;">

						</el-date-picker>
					</el-form-item>
				</div>
				<el-form-item prop="showPath" label="入住申请单">
					<el-upload :disabled="isShow" :limit="1" multiple action="/api/admin/roomManage/uploadRoomFile" :on-remove="removeFile"
						:file-list="fileList" name="file" :on-preview="uploadDown" :headers="headers"
						:on-success="uploadSuccess">
						<el-button :disabled="isShow" size="small" type="primary">点击上传入住申请单</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item prop="requirement" label="入住要求">
					<el-input type="textarea" v-model="formData.requirement" placeholder="请输入入住要求"
					:disabled="formData.register == '已退房'">
					</el-input>
				</el-form-item>
				<el-form-item prop="members" label="其他成员">
					<el-input type="textarea" v-model="formData.members" placeholder="请输入其他成员"
					:disabled="formData.register == '已退房'">
					</el-input>
				</el-form-item>
				<div v-if="isShow && !isCheck">
					<div style="display: flex;justify-content: space-between;">
						<el-form-item prop="createName" label="创建人">
							<el-input v-model="formData.createName" disabled=""></el-input>
						</el-form-item>
						<el-form-item prop="createTime" label="创建时间">
							<el-input v-model="formData.createTime" disabled=""></el-input>
						</el-form-item>
					</div>
					<el-form-item prop="status" label="审批状态">
						<el-input v-model="formData.status" disabled=""></el-input>
					</el-form-item>
					<el-form-item prop="opinion" label="审批意见">
						<el-input type="textarea" v-model="formData.opinion" disabled=""></el-input>
					</el-form-item>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item prop="updateName" label="审批人">
							<el-input v-model="formData.updateName" disabled=""></el-input>
						</el-form-item>
						<el-form-item prop="updateTime" label="审批时间">
							<el-input v-model="formData.updateTime" disabled=""></el-input>
						</el-form-item>
					</div>
				</div>

				<div v-if="isCheck">

					<el-form-item prop="opinion" label="审批意见">
						<el-input type="textarea" v-model="formData.opinion" label="同意入住"></el-input>
					</el-form-item>

					<el-form-item label="审批结果" prop="status">
						<el-radio v-model="formData.status" label="pass">同意</el-radio>
						<el-radio v-model="formData.status" label="reject">驳回</el-radio>
					</el-form-item>

				</div>
			</el-form>
			<span v-if="!isCheck && formData.register != '已退房'" slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>

			<span v-if="isCheck" slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button type="primary" @click="approvalClick">确 定</el-button>
			</span>
			<!--span v-else slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
			</span-->
		</el-dialog>
	</div>
</template>

<script>
import downloadFile from '../../../assets/js/downloadFile.js'
export default {
	props: ["title", "dialogVisible", "obj", "isCheck"],
	watch: {
		"title": function (val) {
			console.log(val)
			if (val == '新增入住') {
				this.isAdd=true;
				this.formData = {
					...this.oldFormData
				}
				console.log(this.formData)
				this.fileList = []
				this.isShow = false
			} else if (val == '查看入住' || val == '审核入住') {
			
				this.isAdd=false;
				this.formData = {
					...this.obj
				}
				console.log(this.formData)
				this.formData.names = this.formData.name
				// this.formData.roomNumber=this.formData.roomNumber
				// this.formData.filePath=this.formData.showPath
				// if (this.formData.fileRes != null) {
				let newFiles = [];
				newFiles.push({
					name: this.formData.showPath,
					url: this.formData.filePath
				});
				this.fileList = newFiles
				console.log(this.fileList)
				// this.fileList[0] = this.formData.showPath;
				// }
				this.isShow = true
				//this.isCheck = this.isCheck;
			} else if (val == '编辑入住') {
				this.isAdd=false;
				this.getRoomTree(this.obj.company)
				this.formData = {
					...this.obj
				}
				console.log(this.formData)
				this.formData.names = this.formData.name
				// this.formData.roomNumber=this.formData.roomNumber
				// this.formData.filePath=this.formData.showPath
				// if (this.formData.fileRes != null) {
				let newFiles = [];
				newFiles.push({
					name: this.formData.showPath,
					url: this.formData.filePath
				});
				this.fileList = newFiles
				// this.fileList[0] = this.formData.showPath;
				// }
				this.isShow = false
				//this.isCheck = this.isCheck;
			}
		}

	},
	data() {
		return {
			isAdd:false,
			headers: {
				Authorization: localStorage.access_token
			},
			isShow: null,
			isCheck: null,
			disabled: false,
			fileList: [],
			options: [],
			oldFormData: "", //初始数据备份
			pickerOptions: {
				disabledDate: (time) => {
					return time.getTime() < new Date(this.formData.checkInTime).getTime()
				}
			},
			pickerOptions1: {
				disabledDate: (time) => {
					if (this.formData.endTime) {
						return time.getTime() > new Date(this.formData.endTime).getTime()
					}
					return false
				}
			},
			formData: {
				checkInTime: null,
				endTime: null,
				roomNumber: null,
				region: null,
				names: null,
				signingDate: null,
				files: [],
				filePath: '',
				status: "",
				contents: null,
				number: null,
				requirement: null,
				members: null,
				showPath: '',
				userId: null,
				water: null,
				property: "单位缴纳",
				opinion: null
			},
			rules: {
				checkInTime: [{
					required: true,
					message: "入住日期不能为空",
					trigger: ["blur", "change"]
				}],
				endTime: [{
					required: true,
					message: "截止日期不能为空",
					trigger: ["blur", "change"]
				}],
				roomNumber: [{
					required: true,
					message: "房间号不能为空",
					trigger: ["blur", "change"]
				}],
				names: [{
					required: true,
					message: "人才姓名不能为空",
					trigger: ["blur", "change"]
				}],
				showPath: [{
					required: true,
					message: "附件不能为空",
					trigger: ["blur", "change"]
				}],
				water: [{
					required: true,
					message: "附件不能为空",
					trigger: ["blur", "change"]
				}],
				property: [{
					required: true,
					message: "附件不能为空",
					trigger: ["blur", "change"]
				}],
				opinion: [{
					required: true,
					message: "请选择审批结果",
					trigger: ["blur", "change"]
				}],
				status: [{
					required: true,
					message: "请选择审批结果",
					trigger: ["blur", "change"]
				}],
			},
			restaurants: [],
			state: '',
			timeout: null
		}
	},
	methods: {

		getRoomTree(company) {
			let newRoomTree = [];
			this.$http.get("/api/roomManage/getRoomTree?company=" + company).then(res => {
				console.log(res);
				res.data.data.forEach((item1, index1) => {
					newRoomTree.push({
						value: item1.building,
						label: item1.building,
						children: [],
					})
					item1.getStoreyRoomResList.forEach((item2, index2) => {
						newRoomTree[index1].children.push({
							value: item2.storey,
							label: item2.storey,
							children: [],

						})
						item2.getRoomResList.forEach((item3, index3) => {
							if (item3.status == '空闲中') {
								newRoomTree[index1].children[index2].children.push({
									value: item3.id,
									label: item3.roomNumber,
								})
							}

						})
					})
				})
				this.options = newRoomTree;
			})
		},
		handleSelect(item) {
			//console.log(item);
			console.log("选中的人才信息：", JSON.stringify(item));
			this.formData.company = item.company
			this.formData.userId = item.userId
			this.formData.phone = item.phone
			this.getRoomTree(item.company)
		},
		tableParValueChange(value, currency, decimals) {
			const digitsRE = /(\d{3})(?=\d)/g
			value = parseFloat(value)
			if (!isFinite(value) || (!value && value !== 0)) return ''
			currency = currency != null ? currency : '$'
			decimals = decimals != null ? decimals : 2
			var stringified = Math.abs(value).toFixed(decimals)
			var _int = decimals ?
				stringified.slice(0, -1 - decimals) :
				stringified
			var i = _int.length % 3
			var head = i > 0 ?
				(_int.slice(0, i) + (_int.length > 3 ? ',' : '')) :
				''
			var _float = decimals ?
				stringified.slice(-1 - decimals) :
				''
			var sign = value < 0 ? '-' : ''
			this.formData.money = sign + currency + head +
				_int.slice(i).replace(digitsRE, '$1,') +
				_float


		},


		uploadDown(obj) {
			console.log(obj)
			this.$confirm('确定下载该文件吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(res => {
				downloadFile(obj);
				this.$message({
					type: 'success',
					message: '下载成功!'
				});
			}).catch(err => {
				this.$message({
					type: 'success',
					message: '取消下载!'
				});
			})

		},
		querySearchAsync(queryString, cb) {
			if (this.formData.names == undefined) {
				this.formData.names = ''
			}
			console.log('formData:', JSON.stringify(this.formData))
			this.$http.get('/api/bdCheckInApply/getTalentByStatusAndCompany?name=' + this.formData.names).then(res => {
				console.log("查询所有单位信息", JSON.stringify(res.data));
				let result = res.data.data;
				cb(result);
			})
		},
		clearSearch() {
			this.$refs.myAutocomplete.handleFocus()
		},
		removeFile(file, fileList) {
			this.formData.filePath = ''
			this.formData.showPath = ''
		},
		//上传附件
		detailFileList(fileList) {

			console.log(fileList)
			// fileList.forEach((item) => {
			// 	if (item.hasOwnProperty('response')) {
			// 		newFiles.push({
			// 			name: item.name,
			// 			url: item.response.data
			// 		})
			// 	} else {
			// 		newFiles.push({
			// 			name: item.name,
			// 			url: item.url
			// 		});
			// 	}
			// })
			this.formData.filePath = fileList[0].response.data.filePath;
			this.formData.showPath = fileList[0].response.data.fileName;

		},
		uploadSuccess(response, file, fileList) {
			this.detailFileList(fileList);
		},
		// 取消
		cancelClick() {
			this.close();
		},

		// 审批
		approvalClick() {
			console.log('formData:', this.formData);
			if(this.formData.status=="未审核"){
				this.$message({
					type: 'error',
					message: '请选择审核结果!'
				});
			}
			this.$refs.formData.validate((valid) => {
				if (valid) {
					this.formData.name = this.formData.names
					this.$emit("doCheckInApply", this.formData)
				} else {
					return;
				}

			})
		},
		// 确定
		confirmClick() {
			this.$refs.formData.validate((valid) => {
				if (valid) {
					if (this.formData.id) {
						this.$emit("updataSubmit", this.formData)
					} else {
						this.formData.name = this.formData.names
						this.$emit("addSubmit", this.formData)
					}

				} else {
					return;
				}

			})

		},
		// 关闭之前的回调
		handleClose(done) {
			this.close();
		},
		// 关闭模态框向父组件传dialogVisible
		close() {
			this.$parent.addClose()
		}
	},
	created() {
		this.oldFormData = JSON.parse(JSON.stringify(this.formData))
		// this.getRoomTree('')
	}
}
</script>

<style scoped="scoped"></style>
